import request from '@/utils/request'



// 获取充值信息 
export function getRechargeList(pageNum) {
    return request({
    url: '/api/recharge/list',
    method: 'get',
    params: {
      pageNum
    }
  })
}

// 获取账户信息
export function getAccountInfo(){
  return request({
    url: '/api/config/accountInfo',
    method: 'get'
  })
}

// 提交充值记录
export function addRecharge(formData) {
  // const formData = new FormData();
  // formData.append('file', file);
  return request({
    url: '/api/recharge/add',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 确保请求头是 multipart/form-data
    }
  })
}
